import { PersonBus } from './PersonBus';
import { BaseBus } from './BaseBus';
import { CommonFunctions } from '../static/common-functions';
import { DateFunctions } from '../static/date-functions';

export class EmployHistoryBus extends BaseBus {

    constructor(data: EmployHistoryBus) {
        super(data);
    }

    setId(id: any) {
        this.employHistId = id;
    }
    initialize(data: EmployHistoryBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
        this.hireDt = CommonFunctions.getDate(data.hireDt);
        this.termDt = CommonFunctions.getDate(data.termDt);
       if (data.termReason)
        { this.termReason = parseInt(data.termReason.toString()); }
        else {
            this.termReason = null;}
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: EmployHistoryBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        this.updateDt = dateNow;
        this.updateUserId = data.insertUserId;
        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
            this.updateUserId = userId;
        }
    }

    personId: any;
    employHistId: any;
    hireDt: Date;
    termDt: Date;
    termReason: number;
    note: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;

    CID(): any {
        super.CID();
        return this.employHistId;
    }

}
